import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=460e89e5&scoped=true&lang=scss"
script.__scopeId = "data-v-460e89e5"

export default script